import { plausibleGoalsApi } from '@/lib/api'
import {
  normalizePlausibleGoalTotals,
  type PlausibleGoalTotals,
  type RawPlausibleGoalTotals,
} from '@/models/plausibleGoals'
import { get } from '@/services/http'

export const PlausibleGoalsService = {
  async formSubmissionTotals(): Promise<PlausibleGoalTotals> {
    const req = get<RawPlausibleGoalTotals>(
      'totals/form-submission',
      undefined,
      {
        client: plausibleGoalsApi,
        dedupe: true,
        retry: { retries: 2 },
      },
    )

    return normalizePlausibleGoalTotals(await req.promise)
  },
}
